import { mapState } from 'vuex';
import { AM_NODATA } from '../../constant';

function data () {
  return {
    // sortOptions: [],
  };
}

const props = {
  // dashboardData: {
  //   required: true,
  //   type: Object
  // },
  // loadingReport: {
  //   required: true,
  //   type: Boolean
  // }
};

const computed = {
  ...mapState({
    user: state => state.user,
    updateReportFilters: state => state.updateReportFilters,
    adminUsers (state) {
      const adminUsers = state.companyAdminsList;
      return adminUsers;
    }
  }),
  noDataText () {
    return AM_NODATA;
  }
};

const methods = {
};

export default {
  data,
  props,
  computed,
  methods
};
